import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import CompareQuotation from "../CompareQuotation/CompareQuotationTask/CompareQuotation";
import {
  getAuditRFQRowData,
  AuditPopRight,
} from "../../store/Audit_Report/actions";

class CompareQuotationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      selectedItems: {},
      maximize: true,
    };
  }

  maximizetogle() {
    this.setState((prevState) => ({
      maximize: !prevState.maximize,
    }));
  }
  callNextCard(id) {
    if (this.props.AuditData.length - 1 === this.props.index) {
      this.props.getAuditRFQRowData({
        ScreenID: id,
      });
      this.setState((prevState) => ({
        maximize: !prevState.maximize,
      }));
    }
  }
  render() {
    var obj = {};
    obj = this.props.obj;
    return (
      <div className={this.state.maximize ? "maximize" : "minimize"}>
        <>
          <Row className="plaseholder">
            <Col
              md={12}
              className="p-1"
              style={{
                width: "70vw",
              }}
            >
              <CompareQuotation CQId={obj.data.ScreenID} AuditReport={true} />
            </Col>
          </Row>
          <Link
            to="#"
            className="strip"
            onClick={() => {
              this.maximizetogle();
              this.props.AuditPopRight(this.props.index);
            }}
          >
            <div className="MaximizeCard-item mb-2 ">
              <div className="MaximizeCard-title-box d-inline-block">
                <span className="mt-4">Quotation ({obj.data.code})</span>
              </div>
            </div>
          </Link>
        </>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  const { AuditData } = state.AuditReport;
  return {
    AuditData,
  };
};

export default withRouter(
  connect(mapStatetoProps, {
    getAuditRFQRowData,
    AuditPopRight,
  })(CompareQuotationCard)
);
